import { fork } from 'redux-saga/effects';

import * as unresolvedList from './complaintUnResolvedList';
import * as resolvedList from './complaintResolvedList';
import * as complaintDetails from './complaintDetails';
import * as resolveComplaint from './resolveComplaint';
import complaintListPagination from './watchers/complaintListPagination';
import resolveComplaintWatcher from './watchers/resolveComplaintWatcher';
import reportMenuVisibility from './watchers/reportMenuVisibility';

export default function* complaintsRootSaga() {
  yield fork(unresolvedList.watcher);
  yield fork(unresolvedList.paginationWatcher);
  yield fork(resolvedList.watcher);
  yield fork(resolvedList.paginationWatcher);
  yield fork(complaintDetails.watcher);
  yield fork(resolveComplaint.watcher);
  yield fork(complaintListPagination);
  yield fork(resolveComplaintWatcher);
  yield fork(reportMenuVisibility);
}



// WEBPACK FOOTER //
// ./src/redux/complaints/sagas.js